'use client';

import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { buildStaticUrl } from '@/constants/endpoints';
import { HELP_ARTICLES } from '@/constants/helpUrls.ts';
import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';
import { useProductTracking } from '@/modules/product/hooks/useProductTracking';

export function BuyerProtectionBanner() {
  const tProduct = useTranslations('product');
  const { sendBuyerProtectionLinkAction } = useProductTracking();
  const { data: product } = useProductBySlugBasicPDP();

  function handleClick() {
    if (product) {
      sendBuyerProtectionLinkAction({
        sellerId: product?.seller?.id,
        productId: product?.id,
      });
    }
  }

  return (
    <div className={styles.bannerContainer}>
      <img
        src={buildStaticUrl('/web/assets/trustPage/shield-tick.png')}
        alt="Buyer Protection"
        width={48}
        height={48}
      />
      <Caption
        colour="base"
        variant="lg-regular"
        className={styles.buyerProtectionMessage}
      >
        {tProduct.rich('BuyerProtection', {
          learnmore: (linkBody) => (
            <a
              href={HELP_ARTICLES.BUYER_PROTECTION}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
              className={styles.zendeskLinkText}
            >
              {linkBody}
            </a>
          ),
        })}
      </Caption>
    </div>
  );
}
